var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconInfoColoredOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1a7 7 0 100 14A7 7 0 008 1zm-.675 10.5V6.615h1.33V11.5h-1.33z",
    fill: "#1D54A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.69 6.018a.76.76 0 00.31.057.785.785 0 00.805-.79.78.78 0 00-.225-.555A.8.8 0 008 4.5a.775.775 0 00-.795.785.77.77 0 00.225.555.76.76 0 00.26.178z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 .5a7.5 7.5 0 11.001 15.001A7.5 7.5 0 018 .5zM7.825 11h.33V7.115h-.33V11z",
    stroke: "#fff"
  })));
}

export default SvgIconInfoColoredOutlined;